/**
 * 落地頁回報「客戶開了簡訊連結」給簡訊狀態 API（lpg-line-invite-sms-sqs 的 POST /sms/opened）。
 * 瓦斯行在訂單上看到「已開啟」靠這一筆。純輔助資訊：任何失敗都吞掉，不影響註冊流程。
 * 不走 apiManager 的 axios instance（它的 401 處理會去重登 LINE）。
 * 練習模式（practice sandbox）不回報。
 */
export interface SmsOpenedPayload {
  invite: string;
  order_id?: string;
  phone?: string;
  k?: string;
}

const DEFAULT_BASE = process.env.REACT_APP_SMS_HTTP_BASE_URL || "";

/**
 * 客服練習沙盒：一律不回報開啟事件。
 * 旗標鍵值與 utils/practice/practiceMode.ts 的 PRACTICE_FLAG_KEY 一致；
 * 不 import 該模組是為了維持本檔「無 alias、Jest 可直接跑」的相依現況。
 */
function isPracticeSandbox(): boolean {
  try {
    if (process.env.REACT_APP_PRACTICE_ONLY === "1") return true;
    return typeof window !== "undefined" && window.sessionStorage?.getItem("practiceMode") === "1";
  } catch {
    return false;
  }
}

export const reportSmsOpened = async (payload: SmsOpenedPayload, baseUrl: string = DEFAULT_BASE): Promise<void> => {
  if (isPracticeSandbox()) return;
  const base = (baseUrl || "").replace(/\/+$/, "");
  if (!base || !payload.order_id || !payload.invite) return;
  const body: SmsOpenedPayload = { invite: payload.invite, order_id: payload.order_id };
  if (payload.phone) body.phone = payload.phone;
  if (payload.k) body.k = payload.k;
  try {
    await fetch(`${base}/sms/opened`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch {
    // 忽略：純輔助資訊
  }
};
